import {
    FETCH_FILTER_BRANDS_BEGIN,
    FETCH_FILTER_BRANDS_SUCCESS,
    FETCH_FILTER_BRANDS_FAILURE,
    FETCH_COMMON_DETAILS_BEGIN,
    FETCH_COMMON_DETAILS_SUCCESS,
    FETCH_COMMON_DETAILS_FAILURE
  } from '../constants/commonActionTypes';

const initialState = {
    brandsFilter: [],
    commonDetails: '',
    isBrandFilterLoading: true,
    error: false,
    isCommonDetailsLoading: true
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    state = initialState;
  }
    switch (action.type) {
      case FETCH_FILTER_BRANDS_BEGIN:
        return {
          ...state,
          isBrandFilterLoading: true,
        };
      case FETCH_FILTER_BRANDS_SUCCESS:
        return {
          ...state,
          brandsFilter: action.payload,
          isBrandFilterLoading: false,
          error: null
        };
      case FETCH_FILTER_BRANDS_FAILURE:
        return {
          ...state,
          error: action.payload,
          isBrandFilterLoading: false
        };
      case FETCH_COMMON_DETAILS_BEGIN:
        return {
          ...state,
          isCommonDetailsLoading: true
        };
      case FETCH_COMMON_DETAILS_SUCCESS:
        return {
          ...state,
          commonDetails: action.payload[0],
          isCommonDetailsLoading: false
        };
      case FETCH_COMMON_DETAILS_FAILURE:
        return {
          ...state,
          error: action.payload,
          isCommonDetailsLoading: false
        };
      default:
        return state;
    }
}
